export default "<main fxFill>\r\n  <router-outlet></router-outlet>\r\n</main>\r\n"